import { useMemo } from "react";

import { useAllLanguages } from "~/modules/country/api/language/languageQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData,getInputDefaultOptionsData } from "~/utils/form/formUtils.ts";


const useLanguageSelectOptions = (includeCtaOption: boolean = false): FormInputOption[] => {
	const { data: languageData } = useAllLanguages();
	return useMemo(() => {
		if (languageData) {
			const options = languageData.map((language) => {
				return createInputOptionData(language.displayName, language.id);
			});

			if (includeCtaOption) {
				return [getInputDefaultOptionsData(), ...options];
			}
			return options;
		}
		return [];
	}, [languageData, includeCtaOption]);
};

export default useLanguageSelectOptions;

